"use strict";

($dt => {

	const controller = {
		Init: () => {
			// Request Options
			const request_options = {
				method: 'POST',
				credentials: 'same-origin',
				redirect: 'error',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: 'location=' + $dt.homepage_popup.location
			};

			// Request Object
			const request = new Request($dt.ajax_url + '?action=discoverycube_check_homepage_poup', request_options);

			// Fetch
			fetch(request).then(response => {
				if (response.status === 200) {
					return response.json();
				} else {
					return;
				}
			}).then(json => {
				if (json && json.status === 'live') {
					const cookie_val = $dt.Util.getCookie(json.key);
					//console.log(cookie_val);

					if (!cookie_val || json.force) {
						// Display Popup
						const on_pre_animate = overlay => {
							overlay.querySelector('.overlay-content').innerHTML = json.html;
						};

						const on_open_complete = () => {
							if (!json.force) {
								const max_age = 30 * 24 * 60 * 60;
								document.cookie = `${json.key}=true;max-age=${max_age};samesite=lax;secure`;
							}
							document.getElementById('homepage-notification-close').addEventListener('click', () => {
								$dt.Overlay.Close();
							});
						};

						$dt.Overlay.Open(on_pre_animate, on_open_complete);
					}
				}
			});
		}
	};

	if ($dt.homepage_popup) {
		$dt.autostart.push(() => {
			controller.Init();
		});
	}

})(window.d3_wp_themejs);
